import { useEffect, useState } from "react";
import axios from "axios";
import {
  FaHourglassHalf,
  FaCheckCircle,
  FaClipboardCheck,
  FaUserCheck,
} from "react-icons/fa";

import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";
import { InboxMetricCard } from "./InboxMetricCard";

export const InboxMetricsOverview = () => {
  const [metrics, setMetrics] = useState({
    myRequests: 0,
    pendingApproval: 0,
    approved: 0,
    candidate: 0,
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const config = { headers: { Authorization: `Bearer ${token}` } };

    const fetchData = async () => {
      // My Requests count
      try {
        const res = await axios.get(`${API_BASE_URL}/api/requests/count`, config);
        setMetrics((prev) => ({ ...prev, myRequests: res.data.totalRequests || 0 }));
      } catch (err) {
        console.error("Error fetching my requests:", err.response?.status, err.message);
      }

      // Pending Approvals count
      try {
        const res = await axios.get(`${API_BASE_URL}/api/requests/pending-approvals/count`, config);
        setMetrics((prev) => ({ ...prev, pendingApproval: res.data.pendingCount || 0 }));
      } catch (err) {
        console.error("Error fetching pending approvals:", err.response?.status, err.message);
      }

      // Approved docket count (use list endpoint and take length)
      try {
        const res = await axios.get(`${API_BASE_URL}/api/requests/approved`, config);
        const approvedCount = Array.isArray(res.data?.data) ? res.data.data.length : 0;
        setMetrics((prev) => ({ ...prev, approved: approvedCount }));
      } catch (err) {
        console.error("Approved count error:", err.response?.status, err.message);
      }

      // Candidates / Completed hires count
      try {
        const res = await axios.get(`${API_BASE_URL}/api/requests/completed-hires/count`, config);
        setMetrics((prev) => ({ ...prev, candidate: res.data.completedCount || 0 }));
      } catch (err) {
        console.error("Error fetching candidate count:", err.response?.status, err.message);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="flex justify-start w-full">
      <div className="grid grid-cols-2 gap-x-6 gap-y-6">
        <Link to="/tables">
          <InboxMetricCard title="My Requests" value={metrics.myRequests} Icon={FaUserCheck} />
        </Link>
        <Link to="/pending">
          <InboxMetricCard title="Pending Approval" value={metrics.pendingApproval} Icon={FaHourglassHalf} />
        </Link>
        <Link to="/approval">
          <InboxMetricCard title="Approved" value={metrics.approved} Icon={FaClipboardCheck} />
        </Link>
          <InboxMetricCard title="Candidates" value={metrics.candidate} Icon={FaCheckCircle} />
      </div>
    </div>
  );
};
